<div>
  <span>{{messagePartA}}</span>
  <a class="id37-link" (click)="goToTest()">{{questionnaire}}</a>
  <span>{{messagePartB}}</span>
</div>
